import { Menu, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import Icon from 'components/Icon'
import { useIntl } from 'react-intl'

export default function CheckboxDropdown({ options, onChange }) {
  const { formatPlural } = useIntl();

  function getPlural(name) {
    const values = {
      Message: { one: 'Message', other: 'Messages' },
      Event: { one: 'Event', other: 'Events' },
      Delivery: { one: 'Delivery', other: 'Deliveries' },
    }

    return values[name][formatPlural(10)];
  }

  return (
    <Menu as="div" className="inline-block text-inherit">
      <div>
        <Menu.Button className="focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
          <Icon
            icon="cog"
            className="hover:primary-darker"
            aria-hidden="true"
          />
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="z-50 bg-white absolute right-0 w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="px-1 py-1 ">
            <Menu.Item>
              <div className="w-full px-2 py-2 text-sm text-gray-400 normal-case">
                Show in history:
              </div>
            </Menu.Item>
            { Object.entries(options).map(([name, value]) => (
              <Menu.Item key={name}>
                {({ active }) => (
                  <button
                    onClick={() => onChange({ ...options, [name]: !value})}
                    className={`${
                      active ? 'bg-primary-lighter text-white' : 'text-gray-900'
                    } group flex rounded items-center w-full px-2 py-2 text-sm`}
                  >
                    {value ? (
                      <Icon
                        icon="check"
                        className="w-5 h-5 mr-2 text-black"
                        aria-hidden="true"
                      />
                    ) : (
                      <Icon
                        icon="timex"
                        className="w-5 h-5 mr-2 text-black"
                        aria-hidden="true"
                      />
                    )}
                    <span>{ getPlural(name) }</span>
                  </button>
                )}
              </Menu.Item>
            )) }
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
